import React from "react";
import styles from "./QuantityEmptySeats.module.scss";
import PlusIcon from "@/assets/icons/plus.svg";

interface QuantityEmptySeatsProps {
  quantity: number;
  setQuantity: (quantity: number) => void;
}

export const QuantityEmptySeats: React.FC<QuantityEmptySeatsProps> = ({
  quantity,
  setQuantity,
}) => {
  const handleQuantity = (type: "minus" | "plus") => {
    if (type === "minus" && quantity > 1) {
      setQuantity(quantity - 1);
    } else if (type === "plus" && quantity < 4) {
      setQuantity(quantity + 1);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>Количество свободных мест</div>
      <div className={styles.quantityContainer}>
        <button
          type="button"
          className={styles.quantityButton}
          onClick={() => handleQuantity("minus")}
          disabled={quantity === 1}
        >
          <span className={styles.minusIcon}>−</span>
        </button>
        <div className={styles.quantityValue}>
          <span>{quantity}</span>
        </div>
        <button
          type="button"
          className={styles.quantityButton}
          onClick={() => handleQuantity("plus")}
          disabled={quantity === 4}
        >
          <img src={PlusIcon} alt="plus" />
        </button>
      </div>
    </div>
  );
};
